import PropTypes from 'prop-types'
import { isNil } from 'ramda'

class BasicObject {
  constructor(init) {
    if (isNil(init)) return undefined
    this._id = init.id
    this.___typename = init.__typename
  }

  static shape = {
    id: PropTypes.string.isRequired,
    __typename: PropTypes.string
  }

  get id() {
    return this._id
  }

  get __typename() {
    return this.___typename
  }

  set __typename(v) {
    this.___typename = v
  }
}

export default BasicObject
